import React from "react";
import styled from "styled-components";
import { Table } from "antd";

interface Props {
  data: any;
  count: number;
  selectPage: number;
  setSelectPage: React.Dispatch<React.SetStateAction<number>>;
  selectVideo: number[];
  setSelectVideo: React.Dispatch<React.SetStateAction<number[]>>;
}

const CustomTable = styled(Table)`
  margin: 17px 0 8px;
`;

export function AddVideoTable({
  data,
  count,
  selectPage,
  setSelectPage,
  selectVideo,
  setSelectVideo,
}: Props) {
  const columns = [
    {
      title: "영상ID",
      dataIndex: "id",
      width: "15%",
    },
    {
      title: "영상 제목",
      dataIndex: "title",
    },
  ];

  const handleSelectTableChange = (selectTable: any) => {
    setSelectVideo(selectTable);
  };

  const rowSelection: any = {
    type: "radio",
    selectedRowKeys: selectVideo,
    onChange: handleSelectTableChange,
  };

  return (
    <CustomTable
      rowKey="id"
      rowSelection={rowSelection}
      columns={columns}
      dataSource={data}
      pagination={{
        current: selectPage,
        pageSize: 5,
        onChange: (page) => setSelectPage(page),
        total: count,
        showSizeChanger: false,
      }}
    />
  );
}
